import { LocationLocationType as LocationTypeDTO, } from '@wix/ambassador-services-catalog-server/types';
import { ServiceLocationType, } from '@wix/bookings-uou-types';
var LocationType;
(function (LocationType) {
    LocationType["CUSTOMER"] = "CUSTOMER";
    LocationType["OTHER"] = "OTHER";
    LocationType["BUSINESS"] = "BUSINESS";
})(LocationType || (LocationType = {}));
export function locationTypeFrom(type) {
    const mapping = new Map([
        ['CUSTOM', LocationType.CUSTOMER],
        ['OWNER_BUSINESS', LocationType.BUSINESS],
        ['OWNER_CUSTOM', LocationType.OTHER],
    ]);
    return mapping.get(type);
}
export function mapBusinessLocationsToServiceLocations(locationsResponse) {
    return locationsResponse.locations.map((businessLocation) => mapServiceLocation({
        businessLocation: businessLocation,
        locationType: ServiceLocationType.OWNER_BUSINESS,
    }));
}
export function mapServiceLocations(schedule) {
    return schedule.availability.useDefaultLocation === false // do not change! If its undefined so it should go to else
        ? schedule.availability?.locations?.map(mapServiceLocation)
        : [mapServiceLocation(schedule.location)];
}
export function mapServiceLocation(location) {
    return {
        type: location.locationType,
        ...(location.address ? { locationText: location.address } : {}),
        ...(location.businessLocation
            ? {
                businessLocation: mapBusinessLocation(location.businessLocation),
            }
            : {}),
    };
}
export function mapBusinessLocation(businessLocation) {
    return {
        id: businessLocation.id,
        name: businessLocation.name,
        default: businessLocation.default,
        phone: businessLocation.phone,
        email: businessLocation.email,
        address: getMappedAddress(businessLocation),
    };
}
function getMappedAddress(businessLocation) {
    const address = businessLocation.address || {};
    if (!address.formattedAddress) {
        address.formattedAddress = '';
    }
    return address;
}
export function mapLocationType(platformLocationType) {
    switch (platformLocationType) {
        case LocationTypeDTO.CUSTOM:
            return ServiceLocationType.CLIENT_PLACE;
        case LocationTypeDTO.OWNER_BUSINESS:
            return ServiceLocationType.OWNER_BUSINESS;
        case LocationTypeDTO.OWNER_CUSTOM:
            return ServiceLocationType.OWNER_CUSTOM;
        default:
            return ServiceLocationType.OWNER_BUSINESS;
    }
}
//# sourceMappingURL=service-location.mapper.js.map